import { ICellEditorAngularComp } from '@ag-grid-community/angular';
import { ICellEditorParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component, Signal } from '@angular/core';
import { FormControl } from '@angular/forms';

import {
  ExtendableDropdownOption,
  ExtendableOptionsDropdownComponent,
} from '@shared/components/extendable-options-dropdown/extendable-options-dropdown.component';

export interface AgProgramProjectDropdownCustomParams {
  items: () => Signal<ExtendableDropdownOption[]>;
  onAddOption: (option: ExtendableDropdownOption) => void;
}

interface AgProgramProjectDropdownParams
  extends AgProgramProjectDropdownCustomParams,
    ICellEditorParams {}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'w-full block h-full',
  },
  imports: [ExtendableOptionsDropdownComponent],
  selector: 'aux-ag-program-project-dropdown',
  styleUrls: ['ag-program-project-dropdown.component.scss'],
  templateUrl: 'ag-program-project-dropdown.component.html',
})
export class AgProgramProjectDropdownComponent implements ICellEditorAngularComp {
  formControl = new FormControl('');
  initialSearchTerm = '';
  items?: Signal<ExtendableDropdownOption[]>;
  params!: AgProgramProjectDropdownParams;

  agInit(params: AgProgramProjectDropdownParams): void {
    this.params = params;
    this.initialSearchTerm =
      typeof params.eventKey === 'string'
        ? params.eventKey.length === 1
          ? params.eventKey
          : ''
        : '';

    this.formControl.setValue(params.value || null);
    this.items = params.items();
  }

  getValue(): string {
    return this.formControl.value ?? '';
  }

  onAddOption(option: ExtendableDropdownOption): void {
    this.params.onAddOption(option);
    this.formControl.setValue(option.value);
  }

  refresh(): boolean {
    return true;
  }

  stopEditing(): void {
    this.params.api.stopEditing();
    this.params.api.setFocusedCell(this.params.rowIndex, this.params.column.getColId());
  }
}
